<template>
    <div id="threeDiv"
      v-bind:okanMain="okanMain"
      v-bind:showThree="showThree"
      v-bind:appartData="appartData"      
    >
      <div id="container"></div>
      <div 
        id="planContainer"   
        v-bind:class="{'minimized' : !planHovered}"
        @click="planHovered=!planHovered"
        @mouseenter="planHovered=true" 
        @mouseleave="planHovered=false" 
      >
        <div 
          id="planDiv"
        ></div>
        <div 
          class="miniPOI"
          v-for="(poi, poiIndex) in three.miniPoi"
          v-bind:key="poiIndex"
          v-bind:id="'mini_' + poiIndex"
          v-bind:style="makePoiPos(poi, poiIndex)"
          v-bind:class="{'current' : poi.numImg == three.miniPoiSelected ,'minimized' : !planHovered}"
          v-show="planHovered"
          @click="changeSphere(poi, $event)"
          @mouseover="displayRoomName(poi, $event)"
          @mouseout="hovering = null"
        ></div>
        <div 
          id="hoverText"
          v-show="hovering !=null && planHovered"
        ></div>
      </div>

      <div id="compassContainer"  class="three" v-show="okanMain.params.boussole">
        <div id="north"></div>
        <div id="compass" class="three"></div>
      </div>  

      

      <div id="vignette" v-show="UIvisible"> </div>

          <span v-show="UIvisible" class="rightSpan1">Molette pour zoomer</span>
          <br />
          <span v-show="UIvisible" class="rightSpan2">Clic gauche maintenu pour déplacer</span>     
          <br />
          <span v-show="UIvisible" class="rightSpan3">Clic sur le mini plan pour naviguer</span> 


      <button id="reOpen" @click="toggleVisible"></button>

      <div id="threeUI"  v-bind:class="{'reduced' : !UIvisible}">
        
        <div id="controlContainer" v-show="UIvisible">
          <div id="decoration"></div>        
          <button id="btnLeft" class="threeButton arrow left" @click="controls(37)"></button>
          <button id="btnRight" class="threeButton arrow right" @click="controls(39)"></button>
          <button id="btnUp" class="threeButton arrow up" @click="controls(38)"></button>
          <button id="btnDown" class="threeButton arrow down" @click="controls(40)"></button>
          <button id="btnPlus" class="threeButton plus" @click="controls(107)"></button>
          <button id="btnMoins" class="threeButton moins" @click="controls(109)"></button>
          <button 
            id="btntoggleAutoRotate" 
            class="threeButton autorotate" 
            v-bind:class="{'active' : three.allowAutoRotate}"
            @click="controls(32)"
          ></button>
        </div>
      </div>   

    <div id="mentionsLegout" v-show="!UIvisible">
      <span><i>* Visuels non contractuels, visite type d'un appartement {{appartData.type.substr(1)}} pièces.</i></span><br/>
      <span class="rightAlign"><i>  Réalisation <a href="http://www.okan3d.com" target="_blank">Okénite Animation</a></i></span>
    </div>  

    </div>

</template>

<script>

import threejs from '../threeScene'

export default {
  name: 'ThreeTest',
  props:{
    okanMain:Object,
    showThree:Boolean,
    appartData: Object
  },
  watch:{
    showThree:{
      handler() {
        if(this.three !=null)
          this.three.windowresize();
      },
      deep: true,
      immediate: true,      
    }
  },
  data() {
    return {
      three: new threejs(this.okanMain),
      UIvisible: true,
      planContainer: null,
      miniPos: [],
      hovering: null,
      planHovered: false,
      showHelp: true,
    }
  },
  methods: {
    controls(code){
      this.three.keyBoardHandler(code,false);
    },
    toggleVisible(){
      this.UIvisible = !this.UIvisible
    },
    makePoiPos(poi, index){
        var offset = (index * 5) ;  //sale 5vmin = taille pitite div à reporter x fois à cause de position : relative
        var  _left;
        _left =  Math.round( 100 * poi.coords.X );

        var returnString = "position: relative; top: calc((" + -offset + "vmin + "+  (100*( poi.coords.Y-1)) + "%)); left: " + _left + "%;";
        return returnString;
    },
    changeSphere(poi, event){
      if(!this.planContainer.classList.contains('minimized')){
        event.stopPropagation();
        this.planHovered=false;
        this.three.loadScene(poi.numImg);
        this.three.controls.forceRotation(poi.prefAngle);
      }

    },
    displayRoomName(poi, event){
      if(!this.planContainer.classList.contains('minimized')){
        this.hovering = poi;
        var targetDiv = document.getElementById('hoverText')
        targetDiv.innerText = poi.name;
        targetDiv.style = "position: fixed; top: calc(" +event.clientY +"px - 8%); left: " + event.clientX + "px; transform: translateX(-50%)";
      }
    }
  },
  mounted() {
      this.planContainer = document.getElementById('planContainer');
      this.three.init();
  }
}
</script>

<style src="../assets/css/three.css"></style>